import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Tooltip, Select, Tag, message } from 'antd';

interface props {
    dados: any;
}

const HistoricoAtendimento: React.FC<props> = (props) => {
    useEffect(() => {
    }, [])

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'nome',
        },
        {
            title: 'Data/Hora Início',
            dataIndex: 'dataHoraInicio',
        },
        {
            title: 'Data/Hora Final',
            dataIndex: 'dataHoraFinal',
        },
        {
            title: 'Motivo',
            dataIndex: 'motivo',
            ellipsis: {
                showTitle: false,
            },
            render: (motivo: any) => (
                <Tooltip placement="topLeft" title={motivo}>
                    {motivo}
                </Tooltip>
            ),
        },
        {
            title: 'Instituição Que Encaminhou',
            render: (record: any) => (
                <p> {record.instituicaoEncaminhamento == null ? <p style={{ textAlign: 'center' }}> --- </p> : record.instituicaoEncaminhamento.descricao} </p>
            ),
        },
        {
            title: 'Meio de Comunicação',
            render: (record: any) => (
                <p> {record.meioComunicacao == null ? <p style={{ textAlign: 'center' }}> --- </p> : record.meioComunicacao.descricao} </p>
            ),
        },
        {
            title: 'Situação',
            dataIndex: 'situacao',
        },
        {
            title: 'Serviços Ofertados',
            dataIndex: 'servicosOfertados',

            render: (servicosOfertados: any) => (
                servicosOfertados ? servicosOfertados.map((option: any, index: any) => {
                    return <Tooltip key={index} title={option.vinculoOrgaoServicoID == 0 ? null : option.vinculoOrgaoServico.servico ? 'Serviço: ' + option.vinculoOrgaoServico.servico.descricao : null}>
                        <Tag key={index}  >
                            <div style={{ whiteSpace: 'pre-wrap' }}>
                                {option.vinculoOrgaoServicoID == 0 ? option.orgaoID !== 0 ? option.nomeOrgao : option.outro : option.vinculoOrgaoServico.orgao ? option.vinculoOrgaoServico.orgao.nome : null}
                            </div>
                        </Tag>
                    </Tooltip>
                }) : null
            )
        },
    ];

    return (
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
                <Table columns={columns} dataSource={props.dados} rowKey={"agendamentoID"} bordered={true}></Table>
            </Col>
        </Row>
    )
}

export default HistoricoAtendimento;